import { render, staticRenderFns } from "./ChangeSuiteDropdown.vue?vue&type=template&id=8b4aa8d8"
import script from "./ChangeSuiteDropdown.vue?vue&type=script&lang=js"
export * from "./ChangeSuiteDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports